import { PkgWarehouse } from '../api/user-package/types/UserPkg'
import { getBrandLogo } from '../helpers/getBrandLogo'
import { WarehousePreview } from './WarehousePreview'

interface Props {
  brand: string
  warehouse: PkgWarehouse
}

export const BrandPreview = ({ brand, warehouse }: Props) => {
  const brandLogo = getBrandLogo(brand)
  return (
    <div className='flex flex-col'>
      {warehouse && (
        <WarehousePreview warehouse={warehouse} className='border-border-default rounded-full border' containerClassName='-mb-2 z-10' />
      )}
      <div className='flex items-center gap-2'>
        <img src={brandLogo} alt={brand} className='w-10' />
        <span className='text-text-primary font-medium'>{brand.toUpperCase()}</span>
      </div>
    </div>
  )
}
